
export default function TourRequirementBadge({ tour }) {
  const points = Number(tour?.required_points || 0);
  const validators = Number(tour?.direct_team_validators || 0);

  if (points <= 0 && validators <= 0) return null;

  return (
    <span className="yesno tourFee">
      <span className="price">
        {points > 0 && (
          <>
            {points} <i className="fa-solid fa-gem"></i>
          </>
        )}
        {points > 0 && validators > 0 && <> / </>}
        {validators > 0 && (
          <>
            {validators} <i className="fa-solid fa-user-check"></i>
          </>
        )}
      </span>
    </span>
  );
}
